export default __webpack_public_path__ + "static/media/Proreview-4.13058624.jpg";